import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FooterService } from 'src/app/core';
import { Errors } from 'src/app/core';

interface SlideItem {
  message: string;
}

interface UserCompany {
  region: string;
}

interface UserProfile {
  company: UserCompany;
}

@Component({
  selector: 'app-notification-slider',
  templateUrl: './notification-slider.component.html',
  styleUrls: ['./notification-slider.component.scss']
})
export class NotificationSliderComponent implements OnInit, OnDestroy {

  @Input() userProfile!: UserProfile;
  @Input() switchRole: string | undefined;
  @Input() autoPlayInterval: number = 5000;

  sanitizedSlides: SafeHtml[] = [];
  errors: Errors = { errors: {} };
  currentIndex = 0;

  private readonly destroy$ = new Subject<void>();
  private autoPlayTimer: any;
  private total = 0;

  constructor(
    private sanitizer: DomSanitizer,
    private footerService: FooterService
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
    this.destroy$.next();
    this.destroy$.complete();
  }

  prev(): void {
    this.currentIndex = (this.currentIndex - 1 + this.total) % this.total;
    this.resetAutoPlay();
  }

  next(): void {
    this.currentIndex = (this.currentIndex + 1) % this.total;
    this.resetAutoPlay();
  }

  goTo(index: number): void {
    this.currentIndex = index;
    this.resetAutoPlay();
  }

  stopAutoPlay(): void {
    clearInterval(this.autoPlayTimer);
  }

  startAutoPlay(): void {
    if (this.total <= 1) { return; }
    this.autoPlayTimer = setInterval(() => { this.next(); }, this.autoPlayInterval);
  }

  private resetAutoPlay(): void {
    this.stopAutoPlay();
    this.startAutoPlay();
  }

  private loadNotifications(): void {
    if (!this.userProfile || !this.userProfile.company || !this.userProfile.company.region) {
      return;
    }

    const queryParams = {
      region: this.userProfile.company.region,
      console: this.switchRole === 'manager' ? 'LEADER' : 'SELLER'
    };

    this.footerService.getBanners(queryParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          let items: SlideItem[] = [];
          if (data && Array.isArray(data)) {
            items = data;
          } else if (data && data.data && Array.isArray(data.data)) {
            items = data.data;
          }
          this.total = items.length;
          this.sanitizedSlides = items.map(item =>
            this.sanitizer.bypassSecurityTrustHtml(item.message)
          );
          setTimeout(() => { this.startAutoPlay(); }, 100);
        },
        error: (err: Errors) => {
          this.errors = err;
        }
      });
  }
}
